import axios from 'axios';
import qs from 'qs';
import { saveAs } from 'file-saver';
import router from '@/router';
import configObj from "@/config";
import { useUserStore } from "@/store";
// 引入日期处理库
import { formatInTimeZone } from 'date-fns-tz';
// 引入ElMessage（假设已全局引入，如未引入需要单独导入）
import { ElMessage } from 'element-plus';

let { baseURL, tokenName, contentType, withCredentials, responseType } = configObj;
let downloadLoadingInstance;
axios.defaults.headers['Content-Type'] = contentType; //配置请求头
axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = withCredentials;
axios.defaults.responseType = responseType;

// 新增：处理日期对象，转换为东八区时间字符串
const formatDateToAsiaShanghai = (date) => {
    // 按业务需求定义格式，这里使用带时分秒的格式
    return formatInTimeZone(date, 'Asia/Shanghai', 'yyyy-MM-dd HH:mm:ss');
};

// 新增：递归处理对象中的所有Date类型
const processDateInData = (data) => {
    if (!data) return data;

    // 如果是Date对象，直接格式化
    if (data instanceof Date) {
        return formatDateToAsiaShanghai(data);
    }

    // 如果是数组，递归处理每个元素
    if (Array.isArray(data)) {
        return data.map(item => processDateInData(item));
    }

    // 如果是对象，递归处理每个属性
    if (typeof data === 'object' && !(data instanceof FormData)) {
        const newData = {};
        Object.keys(data).forEach(key => {
            newData[key] = processDateInData(data[key]);
        });
        return newData;
    }

    // 非对象类型直接返回
    return data;
};

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    const userStore = useUserStore();
    const { token, userInfo } = userStore;
    config.headers[tokenName] = token;
    config.headers["AppID"] = userInfo && userInfo.AppID;

    // 新增：处理数据中的日期对象
    if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
        config.data = processDateInData(config.data);
    }

    if (config.method === 'post' && !config.headers.uploadImg && !config.headers.postBody) {
        config.data = qs.stringify(config.data);
    }
    return config;
}, (error) => {
    console.log('错误的传参')
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    //未登陆
    if (res.data.code !== 1) {
        console.log('未登录状态')
        if(res.data.code === 0){
            ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
            });
            return Promise.reject(res.data);
        }else if(res.data.code){
            const userStore = useUserStore();
            const { afterLogout } = userStore;
            afterLogout();
            router.push({
                path: '/login',
            })
        }
    }else{
        return res.data;
    }
}, (error) => {
    ElMessage({
        showClose: true,
        message: '接口请求异常，请稍后再试~',
        type: "error"
    });
    return Promise.reject(error);
});

/**
 * 返回一个Promise(发送post请求)
 * errorback是否错误回调
 */
export function _post(url, params, errorback) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            })
            .catch((error) => {
                errorback && reject(error);
            })
    })
}

/**
 * 返回一个Promise(发送get请求)
 * errorback是否错误回调
 */
export function _get(url, param, errorback) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: param
        })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                errorback && reject(error);
            })
    })
}
/**
 * 返回一个Promise(发送上传请求)
 * errorback是否错误回调
 */
export function _upload(url, formData, errorback)
{
    return new Promise((resolve, reject) =>
    {
        let headers = {
            "Content-Type": "multipart/form-data",
            "uploadImg": true,
        }
        axios.post(url, formData, { headers })
            .then(response =>
            {
                resolve(response);
            })
            .catch((error) =>
            {
                reject(error);
            })
    })
}
export function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && value !== "" && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result
}
// 验证是否为blob格式
export function blobValidate(data) {
    return data.type !== 'application/json'
}
// 通用下载方法
export function _download(url, params, filename, config) {
    return axios.post(url, params, {
        transformRequest: [(params) => { return tansParams(params) }],
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'blob',
        ...config
    }).then(async (data) => {
        const blob = new Blob([data])
        saveAs(blob, filename)
    }).catch((r) => {
        console.error(r)
    })
}
/**
 * 返回一个Promise(发送post请求)
 * errorback是否错误回调
 */
export function _postBody(url, params, errorback) {
    return new Promise((resolve, reject) => {
        let headers = {
            "Content-Type": 'application/json;charset=UTF-8',
            postBody: true,
        }
        axios.post(url, params, { headers })
            .then(response => {
                resolve(response);
            })
            .catch((error) => {
                errorback && reject(error);
            })
    })
}
export default {
    _post,
    _postBody,
    _get,
    _download,
    _upload
}
